import { render } from "./StandardNotes.vue?vue&type=template&id=4e8ee89b&scoped=true"
import script from "./StandardNotes.vue?vue&type=script&lang=js"
export * from "./StandardNotes.vue?vue&type=script&lang=js"

import "./StandardNotes.vue?vue&type=style&index=0&id=4e8ee89b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4e8ee89b"

export default script